export const currentExecution = (state) => (browser) => {
  if (
    state.tabsData &&
    state.tabsData?.tabs &&
    state.tabsData?.tabs.length > 0 &&
    state.tabsData?.ressourcesindex &&
    typeof state.tabsData?.ressourcesindex[browser] !== "undefined"
  ) {
    let index = state.tabsData.ressourcesindex[browser];
    return state.tabsData.tabs[index];
  }
  return false;
};

export const currentTestResultId = (state) => (browser) => {
  return state.window?.testresult_id || state.tabData?.tabs[state?.tabData?.ressourcesindex[browser]]?.testresult_id || null;
};
